document.addEventListener("DOMContentLoaded", function () {
  const processItems = document.querySelectorAll(".pdp-process-accordion_item");

  processItems.forEach((item) => {
    const btn = item.querySelector(".pdp-process-accordion_btn");
    const content = item.querySelector(".pdp-process-accordion_content");
    const icon = item.querySelector(".pdp-process-accordion_icon");

    // Start closed
    content.style.maxHeight = "0px";

    btn.addEventListener("click", () => {
      const isOpen = item.classList.contains("open");

      /* OPTIONAL: close others (accordion mode) */
      processItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("open");
          const otherContent = otherItem.querySelector(".pdp-process-accordion_content");
          const otherIcon = otherItem.querySelector(".pdp-process-accordion_icon");
          otherContent.style.maxHeight = "0px";
          otherIcon.textContent = "+";
        }
      });

      // Toggle current
      if (isOpen) {
        item.classList.remove("open");
        content.style.maxHeight = "0px";
        icon.textContent = "+";
      } else {
        item.classList.add("open");
        content.style.maxHeight = content.scrollHeight + "px";
        icon.textContent = "–";
      }
    });
  });
});